var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 64,
    viewBox: "0 0 44 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4288 22.8325C37.4627 22.833 41.5547 26.9341 41.5547 32.0005C41.5545 37.0668 37.4623 41.1665 32.4278 41.1665C32.4224 41.1665 32.4145 41.1659 32.3926 41.1655H30.9395C26.5439 41.1648 22.9688 37.5843 22.9688 33.1577V30.8413C22.9688 26.4135 26.5441 22.8337 30.9405 22.8335H32.3106V22.8325C32.3534 22.8329 32.388 22.8339 32.4044 22.8335C32.4224 22.8331 32.4214 22.8327 32.4288 22.8325Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 44.1663H19.9688V53.2249C19.9688 58.3438 15.7844 62.5002 10.6787 62.5002C5.6356 62.5001 1.5001 58.3916 1.5 53.3352C1.5 48.4256 5.34045 44.4235 10.1572 44.178L10.627 44.1663Z",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4278 1.5C37.4623 1.5 41.5547 5.60011 41.5547 10.668C41.5545 15.7342 37.4626 19.8335 32.4288 19.834H22.9688V1.50098H32.3096C32.3427 1.50098 32.375 1.50028 32.3926 1.5C32.4145 1.49966 32.4224 1.5 32.4278 1.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 1.50122H19.9688V19.8342H10.627C5.59244 19.8342 1.50001 15.7341 1.5 10.6663C1.5 5.59988 5.59247 1.50122 10.626 1.50122Z",
    stroke: "white",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.626 22.835H19.9688V41.168H10.627C5.59244 41.168 1.50001 37.0679 1.5 32C1.5 26.9336 5.59247 22.835 10.626 22.835Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/Brand.ff25f5e37e4b26e921123a523c6d6dc1.svg";
export { ForwardRef as ReactComponent };